// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ei-0";
export var headerCellHover = "_ei-1";